import "./style/index.css?global";
import { Checkbox } from "antd";

// @ts-ignore
Checkbox.name = "Checkbox"; // Used by the Field component to determine input type.

export default Checkbox;